import * as z from "zod/v4";

export const deleteSubscribeKeyword = {
  name: "deleteSubscribeKeyword" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ success: z.boolean() }),
};
